import { render } from "./ChatHistory.vue?vue&type=template&id=11589f1c&scoped=true"
import script from "./ChatHistory.vue?vue&type=script&lang=js"
export * from "./ChatHistory.vue?vue&type=script&lang=js"

import "./ChatHistory.vue?vue&type=style&index=0&id=11589f1c&lang=scss&scoped=true"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11589f1c"]])

export default __exports__